import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('Search', new Immutable.List([]))
	.set('Get', new Immutable.List([]))
	.set('Update', new Immutable.Map({}))
	.set('UpdateFree', new Immutable.Map({}))

/*Types*/
export const ACTION_GET_CORRIDA = "ACTION_GET_CORRIDA"
export const ACTION_CORRIDAS_ASIGNACION = "ACTION_CORRIDAS_ASIGNACION"
export const ACTION_GUARDAR_DONATARIA = "ACTION_GUARDAR_DONATARIA"
export const ACTION_LIBERAR_DONATARIA = "ACTION_LIBERAR_DONATARIA"
/*Reducer*/
export default (state = initialState, action) => {

	switch(action.type) {
		case ACTION_GET_CORRIDA:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_CORRIDAS_ASIGNACION:
			return state.set('Get', new Immutable.List(action.Obj))
		case ACTION_GUARDAR_DONATARIA:
			return state.set('Update', new Immutable.Map(action.Obj))
		case ACTION_LIBERAR_DONATARIA:
			return state.set('UpdateFree', new Immutable.Map(action.Obj))
		default:
			return state
	}

}

/*Action Creators*/

export const corridaDelivery = () => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/corridaDelivery',
			method: 'POST',
			data: {},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_CORRIDA, Obj: response.data})
		}).catch(error =>{
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const corridaAsignacion = (form) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/corridaAsignacion',
			method: 'POST',
			data: {...form},
			headers: Object.assign({'Authorization':sessionStorage.access_token, 'uid': sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type: ACTION_CORRIDAS_ASIGNACION, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const guardarDonataria = (form) => {

	let donatariasAsignacion = form.dataT.map((a)=> {
		return {
			comentario: a.comentario || "",
			createdByComentario: sessionStorage.uid,
			createdDateComentario: new Date().toISOString().slice(0, 10),
			idCondicionPago: a.liberar === true ? 1 : a.condicionar === true ? 2 : null,
			idTipoPago: "",
			idDonataria: a.idDonataria
		}
	})

	const tmp = {
		donatariasAsignacion,
		idCorrida: form.corridasDelivery
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/guardarDonataria',
			method: 'POST',
			data: {...tmp},
			headers: Object.assign({'Authorization':sessionStorage.access_token, 'uid': sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type: ACTION_GUARDAR_DONATARIA, Obj: response.data})
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const liberarDonataria = (form) => {

	let donatarias = []

	form.dataT.forEach((a) => {

		if (a.liberar || a.condicionar) {

			if (a.liberar && a.comentario) {
				a.comentario = ""
			}
			let obj =  {
				idDonataria: a.idDonataria,
				nombreDonataria: a.donataria,
				nivelIntervencion: {
					tipo: {
						id: a.idNivel || 0,
						descripcion: a.nivelIntervencion
					},
					montoAutorizado: a.montoAutorizado,
					etapaFortalecimiento: a.etapaDelFortalecimiento || "",
					porcentajeAvancePlanTrabajo: a.porcentajeDeAvancePandeTrabajo || 0,
					totalTecnicasHerramientasConRetraso: a.totalDeTecnicasoHerramientasConRetraso || 0,
					tecnicasHerramientasConMayorRetraso: a.tecnicasOHerramientasConMayorRetraso || "",
					diasRetraso: a.diasDeRetraso || 0,
					liberar: a.liberar === true ? 1 : a.condicionar === true ? 2 : null
				},
				comentario: {
					usuario: sessionStorage.firstname +" "+ sessionStorage.lastname,
					destinatario: 'donataria',
					comentario: a.comentario || "",
					seccion: 'Condiciones de entrega del donativo',
					activo: true
				}
			}
			donatarias.push(obj)
		}
	})

	const tmp = {
		donatarias,
		idCorrida: form.corridasDelivery,
		descripcionOportunidad : form.corrida,
		supervisor : {
			idUsuario : sessionStorage.uid,
			nombreUsuario : sessionStorage.firstname +" "+ sessionStorage.lastname
		}
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/liberarDonataria',
			method: 'POST',
			data: {...tmp},
			headers: Object.assign({'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type: ACTION_LIBERAR_DONATARIA, Obj:response.data})
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearData = () => {

	return (dispatch) => {
		dispatch({ type: ACTION_CORRIDAS_ASIGNACION, Obj: [] })
	}
}



// WEBPACK FOOTER //
// ./src/modules/Delivery/Delivery.js